// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".description-area[data-v-71525ffe]{display:flex;flex-direction:column;gap:4px}.description-area .paragraph[data-v-71525ffe]{display:-webkit-box;-webkit-box-orient:vertical;overflow:hidden;text-overflow:ellipsis}.description-area label[data-v-71525ffe]{cursor:pointer;color:#78a6b8}.description-area label .show-more-checkbox[data-v-71525ffe]{position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;border-width:0}", ""]);
// Exports
module.exports = exports;
